import { useSearchParams } from "react-router";

// useTeamScope reads/writes the active department/team scope from the URL
// (?team=<teams.id>). The URL is the single source of truth — never localStorage
// or a jotai atom — because a team id is galaxy-specific: a stale id carried
// across a galaxy switch would scope one galaxy's view by another galaxy's team
// (a boundary leak). Galaxy switches rebuild the path without the query, so the
// scope clears itself. 0 / absent / unparseable = whole galaxy (undefined).
export function useTeamScope(): { teamId: number | undefined; setTeamId: (id: number | undefined) => void } {
  const [searchParams, setSearchParams] = useSearchParams();
  const raw = Number(searchParams.get("team"));
  const teamId = Number.isFinite(raw) && raw > 0 ? raw : undefined;

  const setTeamId = (id: number | undefined) => {
    setSearchParams(
      (prev) => {
        const next = new URLSearchParams(prev);
        if (id && id > 0) next.set("team", String(id));
        else next.delete("team");
        return next;
      },
      { replace: true },
    );
  };

  return { teamId, setTeamId };
}
